import React from 'react'
import { connect } from 'react-redux'
import _get from 'lodash/get'

import { OboeAudience, TYPE_BRAND, SECTION_MUSICSTREAMING } from '../_library/OboeAudience'
import { getTitle } from '../utils/getTitle'

@connect(state => {
  const brand = state.brands.selected

  return {
    brand,
  }
})
export default class BrandAudienceMusicStreaming extends React.Component {
  componentDidMount() {
    const {
      brand: { displayName },
      configs,
    } = this.props
    const configDocTitle = _get(configs, 'messages.documentTitle', '')
    document.title = getTitle(configDocTitle, [displayName])
  }

  render() {
    const {
      match: {
        params: { id },
      },
    } = this.props
    return (
      <div className="audience-musicstreaming">
        <OboeAudience
          type={TYPE_BRAND}
          section={SECTION_MUSICSTREAMING}
          limitShowing={true}
          data={{
            url: `/api/audience/${id}/`,
            node: 'data.audience.musicstreaming.*',
            param: { type: 'brand', section: 'music' },
          }}
        />
      </div>
    )
  }
}
